"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.fixSpxValues = exports.createUnorderedListDataType = exports.createDataType = exports.findPredicateIndexMatch = exports.predicateUnion = exports.seperatorPrefix = exports.seperatorPredicate = exports.asteriskPredicate = exports.curlyBracesPredicate = exports.typePredicate = exports.customIdentPredicate = exports.dimensionPredicate = exports.stringPredicate = exports.hexaColorPredicate = exports.hexColorPredicate = exports.functionPredicate = exports.unorderedListPredicate = exports.parseDimension = exports.EMPTY_DIMENSION = void 0;
var tslib_1 = require("tslib");
var data_types_consts_1 = require("./data-types-consts");
var DIMENSION_REGEX = /^[+-]?(\d+|\d*\.\d+|\d*\.?\d+[eE][+-]?\d+)(\D*$)/;
var DIMENSION_REGEX_UNIT_INDEX = 2;
var SPX_FORMATTER_REGEX = /^spx\((-?[\d.]+)\)$/;
var SPX_ONLY_REGEX = /^(-?[\d.]+)spx$/;
var CONTAINING_SPX_REGEX = /(-?[\d.]+)spx/;
// TODO: support unicode and escaped characters
var IDENTIFIER_REGEX = /^-?[A-Za-z_]([A-Za-z0-9_-])*/;
var HEX_COLOR_REGEX = /^#([a-fA-F\d]{3}){1,2}$/;
var HEXA_COLOR_REGEX = /^#([a-fA-F\d]{8}|[a-fA-F\d]{4})\b$/;
var EMPTY_UNIT = '';
exports.EMPTY_DIMENSION = { number: 0, unit: EMPTY_UNIT, raw: '0' };
var getSpxValue = function (text) {
    var _a, _b;
    var _c = tslib_1.__read((_a = SPX_FORMATTER_REGEX.exec(text)) !== null && _a !== void 0 ? _a : [], 2), _ = _c[0], spxFormatterValue = _c[1];
    var _d = tslib_1.__read((_b = SPX_ONLY_REGEX.exec(text)) !== null && _b !== void 0 ? _b : [], 2), __ = _d[0], spxValue = _d[1];
    return spxFormatterValue !== null && spxFormatterValue !== void 0 ? spxFormatterValue : spxValue;
};
var parseDimension = function (text) {
    var number = parseFloat(text);
    var spxValue = getSpxValue(text);
    if (typeof spxValue !== 'undefined') {
        return {
            number: Number(spxValue),
            unit: 'spx',
            raw: "spx(".concat(spxValue, ")"),
        };
    }
    if (!isNaN(number)) {
        var dimensionMatch = DIMENSION_REGEX.exec(text);
        return dimensionMatch
            ? { number: number, unit: dimensionMatch[DIMENSION_REGEX_UNIT_INDEX] || EMPTY_UNIT, raw: text }
            : undefined;
    }
    return;
};
exports.parseDimension = parseDimension;
var unorderedListPredicate = function (keywords) {
    return function (ast) {
        return ast.type === 'text' && (typeof keywords === 'string' ? ast.text === keywords : keywords.has(ast.text));
    };
};
exports.unorderedListPredicate = unorderedListPredicate;
var functionPredicate = function (functions) {
    return function (ast) {
        return ast.type === 'call' && (typeof functions === 'string' ? ast.name === functions : functions.has(ast.name));
    };
};
exports.functionPredicate = functionPredicate;
// <hex-color>
// TODO: Match #RRGGBBAA? (Only Internet Explorer doesn't support it)
var hexColorPredicate = function () { return function (ast) {
    return ast.type === 'text' && HEX_COLOR_REGEX.test(ast.text);
}; };
exports.hexColorPredicate = hexColorPredicate;
var hexaColorPredicate = function () { return function (ast) {
    return ast.type === 'text' && HEXA_COLOR_REGEX.test(ast.text);
}; };
exports.hexaColorPredicate = hexaColorPredicate;
// <string>
var stringPredicate = function () { return function (ast) { return ast.type === 'string'; }; };
exports.stringPredicate = stringPredicate;
var dimensionPredicate = function (_a) {
    var _b = _a === void 0 ? {} : _a, units = _b.units, min = _b.min, max = _b.max, _c = _b.nonZero, nonZero = _c === void 0 ? false : _c, _d = _b.integer, integer = _d === void 0 ? false : _d;
    return function (ast) {
        if (ast.type === 'text') {
            var dimension = (0, exports.parseDimension)(ast.text);
            if (!dimension ||
                (min !== undefined && dimension.number < min) ||
                (max !== undefined && dimension.number > max)) {
                return false;
            }
            if (nonZero && dimension.number === 0) {
                return false;
            }
            if (integer) {
                return dimension.number % 1 === 0;
            }
            if (min === undefined && max === undefined && dimension.number === 0) {
                return true;
            }
            if (typeof units === 'string') {
                return dimension.unit === units;
            }
            return units ? units.has(dimension.unit) : !dimension.unit;
        }
        return false;
    };
};
exports.dimensionPredicate = dimensionPredicate;
var customIdentPredicate = function (forbiddenKeywords) {
    return function (ast) {
        return ast.type === 'text' &&
            !(forbiddenKeywords && (0, exports.unorderedListPredicate)(forbiddenKeywords)(ast)) &&
            IDENTIFIER_REGEX.test(ast.text);
    };
};
exports.customIdentPredicate = customIdentPredicate;
var typePredicate = function (typeList) {
    return function (ast, index, items) {
        var startIndex = index !== null && index !== void 0 ? index : 0;
        var astItems = items !== null && items !== void 0 ? items : [{ value: ast }];
        var item;
        var i = startIndex;
        var matchAmount = 0;
        var _loop_1 = function () {
            var itemType = item.value.type;
            if (typeList.every(function (typeItem) { return itemType !== typeItem; })) {
                return "break";
            }
            matchAmount++;
        };
        while ((item = astItems[i++])) {
            var state_1 = _loop_1();
            if (state_1 === "break")
                break;
        }
        return matchAmount;
    };
};
exports.typePredicate = typePredicate;
var curlyBracesPredicate = function (predicates, min, max) {
    return function (ast, index, items) {
        var e_1, _a;
        var startIndex = index !== null && index !== void 0 ? index : 0;
        var astItems = items !== null && items !== void 0 ? items : [{ value: ast }];
        var item;
        var i = startIndex;
        var matchAmount = 0;
        while ((item = astItems[i++])) {
            var match = undefined;
            try {
                for (var predicates_1 = (e_1 = void 0, tslib_1.__values(predicates)), predicates_1_1 = predicates_1.next(); !predicates_1_1.done; predicates_1_1 = predicates_1.next()) {
                    var predicate = predicates_1_1.value;
                    var predicateMatch = predicate(item.value, i - 1, items);
                    if (predicateMatch) {
                        match = predicateMatch;
                        break;
                    }
                }
            }
            catch (e_1_1) { e_1 = { error: e_1_1 }; }
            finally {
                try {
                    if (predicates_1_1 && !predicates_1_1.done && (_a = predicates_1.return)) _a.call(predicates_1);
                }
                finally { if (e_1) throw e_1.error; }
            }
            if (!match || ++matchAmount === max) {
                break;
            }
        }
        return matchAmount >= min ? matchAmount : false;
    };
};
exports.curlyBracesPredicate = curlyBracesPredicate;
var asteriskPredicate = function (predicate) {
    return function (ast, index, items) {
        var startIndex = index !== null && index !== void 0 ? index : 0;
        var astItems = items !== null && items !== void 0 ? items : [{ value: ast }];
        var item;
        var i = startIndex;
        var matchAmount = 0;
        while ((item = astItems[i])) {
            if (!predicate(item.value, i++, astItems)) {
                break;
            }
            matchAmount++;
        }
        return matchAmount;
    };
};
exports.asteriskPredicate = asteriskPredicate;
var seperatorPredicate = function () { return function (ast) {
    return ast.type === '/' && ast.text === data_types_consts_1.INTERNAL_VALUE_SEPERATOR;
}; };
exports.seperatorPredicate = seperatorPredicate;
var seperatorPrefix = function (dataType) { return ({
    dataType: dataType,
    prefixChar: data_types_consts_1.INTERNAL_VALUE_SEPERATOR,
}); };
exports.seperatorPrefix = seperatorPrefix;
var predicateUnion = function (predicates) {
    return function (ast, index, items, prev) {
        var e_2, _a;
        try {
            for (var predicates_2 = tslib_1.__values(predicates), predicates_2_1 = predicates_2.next(); !predicates_2_1.done; predicates_2_1 = predicates_2.next()) {
                var predicate = predicates_2_1.value;
                var predicateMatch = predicate(ast, index, items, prev);
                if (predicateMatch) {
                    return predicateMatch;
                }
            }
        }
        catch (e_2_1) { e_2 = { error: e_2_1 }; }
        finally {
            try {
                if (predicates_2_1 && !predicates_2_1.done && (_a = predicates_2.return)) _a.call(predicates_2);
            }
            finally { if (e_2) throw e_2.error; }
        }
        return false;
    };
};
exports.predicateUnion = predicateUnion;
var findPredicateIndexMatch = function (items, predicate) {
    var item;
    var i = 0;
    while ((item = items[i])) {
        var predicateMatch = predicate(item.value, i, items);
        if (predicateMatch) {
            return { index: i, length: Number(predicateMatch) };
        }
        i++;
    }
    return undefined;
};
exports.findPredicateIndexMatch = findPredicateIndexMatch;
var createDataType = function (dataType, predicates) {
    var dataTypeData = data_types_consts_1.DATA_TYPES_MAP.get(dataType);
    var prefix = (dataTypeData === null || dataTypeData === void 0 ? void 0 : dataTypeData.prefix) ? (0, exports.seperatorPrefix)(dataTypeData.prefix) : undefined;
    return {
        dataType: dataType,
        initial: (0, data_types_consts_1.getInitialValue)(dataType),
        prefix: prefix,
        predicate: function (ast, index, items, prev) {
            var predicateAst = ast;
            var predicateIndex = index;
            if (prefix) {
                if (index === undefined || !items || prev !== prefix.dataType) {
                    return false;
                }
                var prefixType = prefix.prefixChar === data_types_consts_1.INTERNAL_VALUE_SEPERATOR ? '/' : 'text';
                if (ast.type !== prefixType || ast.text !== prefix.prefixChar) {
                    return false;
                }
                predicateIndex = index + 1;
                if (!items[predicateIndex]) {
                    return false;
                }
                predicateAst = items[predicateIndex].value;
            }
            var predicateMatch = (0, exports.predicateUnion)(predicates)(predicateAst, predicateIndex, items, prev);
            if (predicateMatch) {
                return !prefix ? predicateMatch : Number(predicateMatch) + 1;
            }
            return false;
        },
    };
};
exports.createDataType = createDataType;
var createUnorderedListDataType = function (dataType) {
    var dataTypeData = data_types_consts_1.DATA_TYPES_MAP.get(dataType);
    return {
        dataType: dataType,
        initial: (0, data_types_consts_1.getInitialValue)(dataType),
        predicate: (dataTypeData === null || dataTypeData === void 0 ? void 0 : dataTypeData.keywords) ? (0, exports.unorderedListPredicate)(dataTypeData.keywords) : function () { return false; },
    };
};
exports.createUnorderedListDataType = createUnorderedListDataType;
var fixSpxValues = function (values) {
    var valuesWithValidSpx = tslib_1.__assign({}, values);
    Object.entries(valuesWithValidSpx).forEach(function (_a) {
        var _b = tslib_1.__read(_a, 2), key = _b[0], value = _b[1];
        if (typeof value === 'string' && CONTAINING_SPX_REGEX.test(value)) {
            var formattedSpxValue = value.replace(new RegExp(CONTAINING_SPX_REGEX, 'g'), function (spxVal) { var _a; return ((_a = (0, exports.parseDimension)(spxVal)) === null || _a === void 0 ? void 0 : _a.raw) || spxVal; });
            valuesWithValidSpx[key] = formattedSpxValue || value;
        }
    });
    return valuesWithValidSpx;
};
exports.fixSpxValues = fixSpxValues;
//# sourceMappingURL=data-types-utils.js.map